import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { InvoiceSortField, SortingOrder } from "@/graphql/codegen/graphql"

// z.string().date() validates strict ISO-8601 calendar dates (rejects 2026-02-30, 2026-13-01, etc.).
const isoDateSchema = fallback(z.string().date().optional(), undefined)

export const payableApprovalsSearchParamsSchema = z.object({
  query: fallback(z.string().max(200).optional().default(""), ""),

  // Sort defaults per AC #2 (Date Entered descending). Required-with-fallback so the
  // default is applied on first load.
  field: fallback(z.nativeEnum(InvoiceSortField), InvoiceSortField.DateEntered),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),

  dueDateFrom: isoDateSchema,
  dueDateTo: isoDateSchema,
})

export type PayableApprovalsSearchParams = z.infer<typeof payableApprovalsSearchParamsSchema>
